import htmlBW from '../../assets/images/htmlBW.webp';
import htmlC from '../../assets/images/htmlC.webp';
import cssBW from '../../assets/images/cssBW.webp';
import cssC from '../../assets/images/cssC.webp';
import jsC from '../../assets/images/jsC.webp';
import jsBW from '../../assets/images/jsBW.webp';
import sassC from '../../assets/images/sassC.webp';
import sassBW from '../../assets/images/sassBW.webp';
import reactC from '../../assets/images/reactC.webp';
import reactBW from '../../assets/images/reactBW.webp';
import tsC from '../../assets/images/tsC.webp';
import tsBW from '../../assets/images/tsBW.webp';
import scC from '../../assets/images/scC.webp';
import scBW from '../../assets/images/scBW.webp';
import jestC from '../../assets/images/jestC.webp';
import jestBW from '../../assets/images/jestBW.webp';
import nodeC from '../../assets/images/nodeC.webp';
import nodeBW from '../../assets/images/nodeBW.webp';
import expressC from '../../assets/images/expressC.webp';
import expressBW from '../../assets/images/expressBW.webp';
import postmanC from '../../assets/images/postmanC.webp';
import postmanBW from '../../assets/images/postmanBW.webp';
import mongoC from '../../assets/images/mongoDbC.webp';
import mongoBW from '../../assets/images/mongoDb.webp';
import gsapC from '../../assets/images/gsapC.webp';
import gsapBW from '../../assets/images/gsapBW.webp';
import framerC from '../../assets/images/framerMotionC.webp';
import framerBW from '../../assets/images/framerMotionBW.webp';
import gitC from '../../assets/images/gitC.webp';
import gitBW from '../../assets/images/gitBW.webp';


export const aboutData = [
    {
        title: "HTML",
        image: htmlC,
        image2: htmlBW
    },
    {
        title: "CSS",
        image: cssC,
        image2: cssBW
    },
    {
        title: "JavaScript",
        image: jsC,
        image2: jsBW
    },
    {
        title: "Scss",
        image: sassC,
        image2: sassBW
    },
    {
        title: "React",
        image: reactC,
        image2: reactBW
    },
    {
        title: "TypeScript",
        image: tsC,
        image2: tsBW
    },
    {
        title: "Styled-Components",
        image: scC,
        image2: scBW
    },
    {
        title: "Jest",
        image: jestC,
        image2: jestBW
    },
    {
        title: "NodeJs",
        image: nodeC,
        image2: nodeBW
    },
    {
        title: "Express",
        image: expressC,
        image2: expressBW
    },
    {
        title: "Postman",
        image: postmanC,
        image2: postmanBW
    },
    {
        title: "MongoDb",
        image: mongoC,
        image2: mongoBW
    },
    {
        title: "Gsap",
        image: gsapC,
        image2: gsapBW
    },
    {
        title: "FramerMotion",
        image: framerC,
        image2: framerBW
    },
    {
        title: "Git",
        image: gitC,
        image2: gitBW
    }
]